import { render, staticRenderFns } from "./HubUserDeliveryConfig.vue?vue&type=template&id=48b4cb36"
import script from "./HubUserDeliveryConfig.vue?vue&type=script&lang=js"
export * from "./HubUserDeliveryConfig.vue?vue&type=script&lang=js"
import style0 from "./HubUserDeliveryConfig.vue?vue&type=style&index=0&id=48b4cb36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports